// extracted by mini-css-extract-plugin
module.exports = {"customInput":"InputFile_customInput__r4Tsj","iconInput":"InputFile_iconInput__1krd3"};